import styled from "styled-components";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const HeaderContainer = styled.div({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

export const TextContainer = styled.div(({ theme }) => {
    return {
        padding: `0 calc(${theme.spacing.xxLarge} + ${theme.spacing.xSmall})`,
    };
});

export const TitleTextContainer = styled.div(({ theme }) => {
    return {
        marginBottom: theme.spacing.xxSmall,
    };
});

export const SecondaryCTATextButton = styled(TextButton)(({ theme }) => ({
    width: "auto",
    margin: "auto",
    marginTop: theme.spacing.small,
    marginBottom: theme.spacing.xSmall,
}));

export const CTAContainer = styled.div({
    textAlign: "center",
    width: "100%",
    paddingBottom: `var(--sab, 0px)`,
});

export const LottieContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    height: `calc(26 * ${theme.spacing.xSmall})`,
}));
